import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { I18nModule } from '../i18n';
import { CfControlComponent } from './cf-control.component';
import { CfControlService } from './cf-control.service';
import { CplaceControlService } from './components/shared/cplace-control.service';
import { CfControlPluginService } from './plugins';

@NgModule({
  declarations: [CfControlComponent],
  imports: [CommonModule, I18nModule, HttpClientModule],
  exports: [CfControlComponent],
  providers: [CfControlPluginService, CplaceControlService, CfControlService],
})
export class CfControlModule {}
